import { InputPassword } from "./input";

export const Input = Object.assign(
  {},
  {
    Password: InputPassword,
  },
);
